(ns hai.journal2.routes
  (:require
   [hai.journal2.events]
   [hai.journal2.page :as page]
   [hai.ui.icons :as icons]
   [hai.ui.rf-sugar :refer [>e]]
   [hai.web-app.routing :as routing]))

(defn routes []
  [["/timelines"
    {:icon icons/humble-timeline}
    [""
     {:name :timelines/view
      :label "Progress timeline"
      :view page/page
      ::routing/window-title "Progress timeline"
      :controllers [{:start (fn []
                              (>e [:timeline/init]))
                     :stop (fn [] (>e [:timeline/teardown]))}]}]]
   ;; Legacy redirects
   ["/timeline"
    ["/entries"
     {:name :timeline/entries-redirect
      :controllers [{:start (fn [] (>e [:routing/navigate [:timelines/view]]))}]}]]
   ["/journal-2"
    ["/entries"
     {:name :timeline/journal2-redirect
      :controllers [{:start (fn [] (>e [:routing/navigate [:timelines/view]]))}]}]]])
